import * as PIXI from "pixi.js";
import {CANVAS, REEL} from "../constants/configs";
import {pixiComponents} from "../index";
import {isMobile} from "pixi.js";
import {gsap} from "gsap";

const bonusWinAmountBoardConfigs = {
    scale: isMobile.phone ? 0.65 : 1,
    fixPoint: isMobile.phone ? 0 : 7,
};

const textStyle = new PIXI.TextStyle({
    fontFamily: 'BebasNeue',
    fontWeight: 500,
    fill: ['#ffffff', '#c0c0c0'],
    dropShadow: true,
    dropShadowColor: 'rgba(0,0,0,0.68)',
    dropShadowBlur: 2,
    dropShadowAngle: Math.PI / 4,
    dropShadowDistance: 2,
    fontSize: 40,
});

// export const getBonusWinAmountBoardPosition = () => ({
//     x: pixiComponents.app.screen.width / 2 + 2,
//     y: 35//pixiComponents.reelsBackgroundContainer.y + (REELS.height * pixiComponents.reelsBackgroundContainer.scale.y) + bonusWinAmountBoardConfigs.fixPoint,
// })

export const getBonusWinAmountBoardPosition = () => ({
    x: pixiComponents.slotBoard.container.width / 2,
    y: 10//pixiComponents.reelsBackgroundContainer.y + (REELS.height * pixiComponents.reelsBackgroundContainer.scale.y) + bonusWinAmountBoardConfigs.fixPoint,
})

export const addBonusWinAmountBoard = () => {
    const container = new PIXI.Container();

    const background = new PIXI.Sprite(PIXI.Texture.from("./assets/tumbleWinBoardBg.webp"));

    const text = new PIXI.Text("10000 FUN", textStyle)
    text.anchor.set(0.5);
    text.position.set(background.width / 2, background.height / 1.8);

    container.addChild(background, text);

    // container.pivot.set(container.width / 2, container.height / 2);
    // const {x, y} = getBonusWinAmountBoardPosition();
    // container.position.set(x, y);

    container.pivot.set(container.width / 2, container.height);
    const {x, y} = getBonusWinAmountBoardPosition();
    container.position.set(x, y);

    container.scale.set(bonusWinAmountBoardConfigs.scale);

    pixiComponents.slotBoard.container.addChild(container);
    pixiComponents.bonusWinAmountBoard = {container, background, text};
    container.visible = false;
}

export const setBonusWinAmountBoardAmount = (text) => {
    pixiComponents.bonusWinAmountBoard.text.text = text;
}

export const showBonusWinAmountBoard = () => {

    const bonusWinAmountBoard = pixiComponents.bonusWinAmountBoard.container;
    bonusWinAmountBoard.visible = false;
    bonusWinAmountBoard.alpha = 0;

    const {y} = getBonusWinAmountBoardPosition();

    gsap.to(bonusWinAmountBoard, {
        alpha: 1,
    });

    gsap.from(bonusWinAmountBoard, {
        y: y+20,
        onComplete: ()=>{
            const {x, y} = getBonusWinAmountBoardPosition();
            pixiComponents.bonusWinAmountBoard.container.position.set(x, y);
        }
    });

}

export const hideBonusWinAmountBoard = () => pixiComponents.bonusWinAmountBoard.container.visible = false;

